import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// Get the appropriate API URL from environment variables
const API_URL = process.env.REACT_APP_API_URL;

// Create axios instance with environment-specific base URL
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-type": "application/json",
  },
});
  
  // Request Interceptor
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `${token}`; // Corrected token format
      }
      return config;
    },
    (error) => {
      console.error("Request error:", error);
      return Promise.reject(error);
    }
  );
  
  // Response Interceptor
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        error.response &&
        error.response.status === 403 &&
        error.response.data.message === "Token invalid"
      ) {
        // Clear the token and redirect to login
        localStorage.removeItem("token");
        toast.error("Session expired. Please log in again.");
        setTimeout(() => {
          window.location.href = "/login"; // Use programmatic navigation in a React component
        }, 2000);
      }
      return Promise.reject(error);
    }
  );
  
  export default axiosInstance;
  

export const regex = {
  onlyNumbers: /^[0-9]+$/,
  onlyAlphabets: /^[A-Za-z]+$/,
  alphanumeric: /^[A-Za-z0-9]+$/,
  validEmail: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
  phoneNumber: /^\d{10}$|^\d{3}[-\s]?\d{3}[-\s]?\d{4}$/,
  date: /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/,
  sixDigitPincode: /^\d{6}$/,
  roleId: /^\d{1,6}$/,
  indianGST: /^(\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d[Z]{1}[A-Z\d]{1})$/,
  gstNumber: /^[0-9]{11}$/,
  time: /^(0[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/,
};
